/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

enum ActionTypes {
  // Reset reducer
  RESET_STATE = 'gfm/oauth/RESET_STATE',
  RESET_TOKEN = 'gfm/oauth/RESET_TOKEN',
  // Set reducer
  SET_TOKEN = 'gfm/oauth/SET_TOKEN',
  GETTING_TOKEN = 'gfm/oauth/GETTING_TOKEN',
  SET_INTROSPECT = 'gfm/oauth/SET_INTROSPECT',
  // Requests
  GET_TOKEN_REQUEST = 'gfm/oauth/GET_TOKEN_REQUEST',
  GET_INTROSPECT_REQUEST = 'gfm/oauth/GET_INTROSPECT_REQUEST',
  // Requests statuses
  SET_GET_TOKEN_REQUEST_STATUS = 'gfm/oauth/SET_GET_TOKEN_REQUEST_STATUS',
  SET_GET_INTROSPECT_REQUEST_STATUS = 'gfm/oauth/SET_GET_INTROSPECT_REQUEST_STATUS',
  // FORBIDDEN ACCESS
  FORBIDDEN_ACCESS = 'gfm/oauth/FORBIDDEN_ACCESS',
}

export default ActionTypes;
